<div class="fitment-section">
  <!-- Search Fitment Form (for regular search when fitment not checked) -->
  <app-fitment-search-form 
    *ngIf="shouldShowFitmentForm()"
    (onCheckFitment)="handleFitmentCheck($event)">
  </app-fitment-search-form>

  <!-- Fitment Success Message (for regular search with valid fitment) -->
  <div *ngIf="shouldShowFitmentSuccess()" class="fitment-success">
    <h2 class="colored-head">
      <input type="checkbox" class="regular-checkbox" checked readonly disabled> 
      Fits {{ getVehicleText() }}
    </h2>
  </div>

  <!-- Fitment Failure Message (for regular search with no fitment) -->
  <div *ngIf="shouldShowFitmentFailure()" class="fitment-failure">
    <div class="row">
      <div class="col-md-12">
        <h4 class="pt-2 pb-1 pl-3 alert-danger">No fitment found.</h4>
      </div>
    </div>
  </div>

  <!-- Divider -->
  <div class="b-line" *ngIf="!isSearchBySize"></div>
</div>
